const m12Section = {
  id: 'm12',
  name: '2027ScoresheetM12Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM12Sub2Label',
      id: 'm12_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        },
      ]
    },
    {
      scoring: '2027ScoresheetM12Sub3Label',
      id: 'm12_scoring_2',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        },
      ]
    }
  ]
}

export default m12Section;